import React,{forwardRef} from 'react'
import ServiceAttributeAssociationForm from './ServiceAttributeAssociationForm';

const AddServiceAttributeAssociation = forwardRef((props, ref) => {
    const {
        formData,
        saveServiceAttributeAssociate,
        serviceAttributeAssUpdateData,
        formValidateError
    } = props;
    return (
        <>
            <ServiceAttributeAssociationForm
                formValidateError = {formValidateError}
                formData={formData}
                saveServiceAttributeAssociate={saveServiceAttributeAssociate}
                serviceAttributeAssUpdateData={serviceAttributeAssUpdateData}
                formActionType={'insert'}
                isInfoOpenHandler={props.isInfoOpenHandler}
                ref={ref}
            />
        </>
    )
})

export default AddServiceAttributeAssociation